import { Link } from "react-router-dom";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";

/** Eye icon next to an order reference that opens the purchase order (Watch list, Purchase orders, Transactions). */
export function CtcViewOrderLink({ poId }: { poId: string }) {
    return (
        <Tooltip label="View order">
            <ActionIcon component={Link} to={`/ctc/orders/${poId}`} variant="subtle" size="sm" aria-label="View order">
                <IconEye size={16} />
            </ActionIcon>
        </Tooltip>
    );
}
